import * as d3 from 'd3';
import { weekRange } from '../../../lib/chartHelpers.js';
import Axis from './Axis.js';

export default class UnitsWeekAxis extends Axis {
  constructor(props) {
    super(props);

    const {
      options: { scaleType },
    } = props;

    this.axis = d3
      .axisBottom(this.xScale)
      .ticks(d3.timeSunday)
      .tickFormat(
        scaleType === 'week'
          ? weekRange(this.weekCount, '%m/%d')
          : weekRange(this.weekCount, '%d')
      )
      .tickPadding(20);
  }

  positionText() {
    const {
      chart,
      options: { width, weekCount, scaleType },
    } = this.props;

    if (scaleType === 'week') {
      chart
        .selectAll('.week .tick text')
        .attr('transform', `translate(${width / weekCount / 2}, -18)`);
    } else if (scaleType === 'month') {
      chart
        .selectAll('.week .tick text')
        .attr('transform', `translate(${width / 17.5 / 2}, 0)`);
    } else {
      chart.selectAll('.week .tick text').attr('opacity', '0');
    }

    return this;
  }

  positionLines() {
    const {
      chart,
      options: { height, padding, scaleType },
    } = this.props;
    if (scaleType === 'month') {
      chart
        .selectAll('.week .tick line')
        .transition()
        .duration(0)
        .attr('stroke-dasharray', '3,3')
        .attr('y2', height + padding * 2);
    }
    return this;
  }

  removeLines() {
    const {
      chart,
      options: { scaleType },
    } = this.props;
    if (scaleType !== 'month') {
      chart.selectAll('.week line').remove();
    }
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.week .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.week')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.positionText().removeDomainPath().positionLines().removeLines();
  }

  build() {
    const { chart } = this.props;
    chart
      .append('g')
      .attr('class', 'axis week')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.positionText()
      .removeDomainPath()
      .positionText()
      .positionLines()
      .removeLines();
  }

  getStartX(datum) {
    return this.xScale(datum.startDate);
  }

  getEndX(datum) {
    return this.xScale(datum.endDate);
  }
}
